import React from "react";
import { CheckCircle2, ChevronRight, ArrowRight } from "lucide-react";

export default function BidChecklist({ steps, nextKey, complete, onGo }) {
  if (!steps?.length) return null;
  const nextStep = steps.find((s) => s.key === nextKey);
  return (
    <div className="shrink-0 bg-white border-b border-slate-100 px-5 py-2 flex items-center gap-1 overflow-x-auto" data-testid="bid-checklist">
      <span className="text-[10px] uppercase tracking-wider text-slate-400 mr-2 shrink-0">Next steps</span>
      {steps.map((s, i) => (
        <React.Fragment key={s.key}>
          <button onClick={() => onGo(s.tab)} title={s.hint} data-testid={`checklist-step-${s.key}`}
            className={`group flex items-center gap-1.5 rounded-full pl-1 pr-2.5 py-1 text-xs shrink-0 transition ${
              s.done ? "text-emerald-700" : s.key === nextKey ? "bg-[#F4C400]/20 text-[#8a6d00] ring-1 ring-[#F4C400]" : "text-slate-400 hover:text-slate-600"}`}>
            {s.done
              ? <CheckCircle2 className="w-4 h-4 text-emerald-500" />
              : <span className={`w-4 h-4 rounded-full grid place-items-center text-[9px] font-bold ${s.key === nextKey ? "bg-[#F4C400] text-black" : "border border-slate-300 text-slate-400"}`}>{i + 1}</span>}
            <span className="font-medium whitespace-nowrap">{s.label}</span>
          </button>
          {i < steps.length - 1 && <ChevronRight className="w-3 h-3 text-slate-300 shrink-0" />}
        </React.Fragment>
      ))}
      {nextStep ? (
        <button onClick={() => onGo(nextStep.tab)} data-testid="checklist-next-cta"
          className="ml-auto shrink-0 text-xs font-semibold text-[#003E87] hover:underline flex items-center gap-1 whitespace-nowrap">
          Do next: {nextStep.label} <ArrowRight className="w-3 h-3" />
        </button>
      ) : (
        <span className="ml-auto shrink-0 text-xs text-emerald-600 font-medium flex items-center gap-1" data-testid="checklist-complete">
          <CheckCircle2 className="w-4 h-4" /> Every step done
        </span>
      )}
    </div>
  );
}
